import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = r(
  (m, e) => /* @__PURE__ */ a.jsx(
    i,
    {
      ref: e,
      ...m,
      image: (o) => /* @__PURE__ */ a.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 32,
          height: 32,
          fill: "none",
          viewBox: "0 0 32 32",
          ...o,
          children: /* @__PURE__ */ a.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m10 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m12 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0M16 24a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m-8 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0m16-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0-2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m-5-8a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0-2a4 4 0 1 0 0 8 4 4 0 0 0 0-8M9 16a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-2 0a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
l.displayName = "AcneIcon";
export {
  l as AcneIcon,
  l as default
};
//# sourceMappingURL=index.js.map
